function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const variantEl = document.querySelectorAll(".variant-val");

// if (document.body.classList.contains("product")) {
//   var renderSezzle = new AwesomeSezzle({
//     amount: document.querySelector("#sezzle-widget").dataset.price,
//     widgetType: "product-page",
//     renderElement: "sezzle-widget",
//   });

//   renderSezzle.init();
// }

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function findSelectedVariant() {
  var selectedVariantId = parseInt(document.querySelector('[name="id"]').value);
  var product = JSON.parse(document.getElementById("data-product").textContent);
  var selectedVariant;

  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].id === selectedVariantId) {
      selectedVariant = product.variants[i];
      break;
    }
  }

  return selectedVariant;
}

function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
      "."
    )
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return "_" + size + match;
    });
}

function findSelectedProductList() {
  var selectedVariant = document.querySelector('[name="Flavor"]:checked').value;
  var product = JSON.parse(document.getElementById("data-product").textContent);
  var filteredProducts = product.variants.filter(
    (variant) => variant.option1 == selectedVariant
  );
  return filteredProducts;
}

function mobileCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

function changeBuyNowForm(variant) {
  var sellingPlan = document.querySelector("input[name=selling_plan]:checked");
  const buyNowForm = document.querySelector("#buyNow");
  var variable = variant.id ? variant.id : variant;

  buyNowForm.action =
    sellingPlan && sellingPlan !== ""
      ? `/cart/clear?return_to=/cart/add?items[][id]=${variable}%26items[][quantity]=1%26items[][selling_plan]=${sellingPlan.value}%26return_to=/checkout`
      : `/cart/clear?return_to=/cart/add?items[][id]=${variable}%26items[][quantity]=1%26return_to=/checkout`;
}

function showSalesBadge(variant) {
  if (!variant) return;

  var saleBadge = document.querySelector("[data-discount-tag]");
  var saleDiscount = document.querySelector("[data-discount-value]");
  var originalPrice =
    variant.compare_at_price != null ? variant.compare_at_price : variant.price;

  if (variant.compare_at_price) {
    saleBadge.classList.remove("hidden");
    saleDiscount.innerHTML =
      Math.floor(((originalPrice - variant.price) * 100) / originalPrice) +
      "% OFF";
  } else {
    saleBadge.classList.add("hidden");
  }
}

function priceBlockUpdate(variant) {
  var isSubscription = document.querySelector(
    "input[name=selling_plan]:checked"
  );
  var originalPrice =
    variant.compare_at_price != null ? variant.compare_at_price : variant.price;
  var actualPrice =
    isSubscription && isSubscription.value != ""
      ? variant.price - variant.price * 0.2
      : variant.price;
  var priceBlock = document.querySelector(".price-main-block");
  var priceHtml = `<div class="price  flex items-center mt-2 mb-4 sm:-mr-2"> 
      <div class="price__container">
        ${
          variant.compare_at_price
            ? `<div class="price__sale flex items-center">
          <span class="visually-hidden visually-hidden--inline">{{ 'products.product.price.sale_price' | t }}</span>
          <span class="price-item price-item--sale price-item--last text-accent-1 text-2xl font-semibold">
            $${(actualPrice / 100).toFixed(2)}
          </span>
          <span class="visually-hidden visually-hidden--inline">{{ 'products.product.price.regular_price' | t }}</span>
          <span>
            <s class="price-item price-item--regular ml-1.5 text-lg text-gray-500">
              $${(originalPrice / 100).toFixed(2)}
            </s>
          </span>
          <div class="py-0.5 px-2 font-semibold rounded bg-accent-2-light text-accent-1 text-xs ml-5 transition duration-150 ease"> 
              ${Math.floor(
                ((originalPrice - actualPrice) * 100) / originalPrice
              )}% OFF
          </div>
          </div>`
            : `<div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">{{ 'products.product.price.regular_price' | t }}</span>
              <span class="price-item price-item--regular text-2xl font-semibold">
                $${(actualPrice / 100).toFixed(2)}
              </span>
          </div>`
        }
      </div>
    </div>`;

  if (priceBlock) {
    priceBlock.innerHTML = priceHtml;
  }
}

function variantPriceChange(currentVariant) {
  var isSubscription = document.querySelector(
    "input[name=selling_plan]:checked"
  );
  var subscriptionDiscount = document.querySelector("[data-subscription]");
  var sezzleWidget = document.querySelector("#sezzle-widget");
  var subscriptionDiscountValue = !subscriptionDiscount
    ? 1
    : subscriptionDiscount.getAttribute("data-subscription-discount");
  var newPrice = (currentVariant.price / 100).toFixed(2);

  if (isSubscription && isSubscription.value != "") {
    var newPrice = (newPrice * (1 - subscriptionDiscountValue / 100)).toFixed(
      2
    );
    sezzleWidget.classList.add("opacity-0");
  } else {
    renderSezzle.alterPrice(`$${newPrice}`);
    sezzleWidget.classList.remove("opacity-0");
  }

  if (document.querySelector("[data-final-price]")) {
    console.log("data-final-price", newPrice);
    document.querySelector("[data-final-price]").innerHTML = "$" + newPrice;
  }

  // console.log(newPrice);

  // document.querySelector(".price-item--regular").innerHTML = "$" + newPrice;

  changeBuyNowForm(currentVariant);

  return [subscriptionDiscountValue, currentVariant];
}

function variantChangeFunc(currentVariant) {
  var quantityRadios = document.querySelector(".quantity_radios");
  var data = variantPriceChange(currentVariant);
  var newPrice = (data[1].price / 100).toFixed(2);
  var savePrice = (newPrice * (data[0] / 100)).toFixed(2);
  var oneTimeElm = document.querySelector("[data-price-one-time]");
  var SubscriptionElm = document.querySelector("[data-price-subscription]");
  var SubscriptionSaveElm = document.querySelector("[data-price-save]");

  let final_price = newPrice;
  const membership_price_wrapper = document.querySelector("[data-membership]");
  if (membership_price_wrapper) {
    let memberPrice = newPrice;
    let elitePrice = newPrice;

    const memberPriceContainer = document.querySelector(
      `[data-vid='${currentVariant.id}']`
    );
    if (memberPriceContainer) {
      memberPrice = memberPriceContainer.dataset.m;
    }
    if (memberPriceContainer) {
      elitePrice = memberPriceContainer.dataset.e;
    }
    if (document.querySelector("[data-membership]").dataset.membership) {
      final_price = Number(
        document.querySelector("[data-membership]").dataset.membership ==
          "elite_member"
          ? elitePrice
          : memberPrice
      ).toFixed(2);
    }
  }
  if (oneTimeElm) {
    oneTimeElm.innerHTML = " $" + final_price;
  }
  if (SubscriptionElm) {
    SubscriptionElm.innerHTML =
      "$" + (newPrice * (1 - data[0] / 100)).toFixed(2);
  }
  if (SubscriptionSaveElm) {
    SubscriptionSaveElm.innerHTML = `(-$${savePrice})`;
  }

  // showSalesBadge(currentVariant);
  priceBlockUpdate(currentVariant);

  if (quantityRadios) {
    // for (var i = 0; i < quantityRadios.querySelectorAll('input').length; i++) {
    //   var priceEach = data[3].price * (parseInt(selectedVariantList[i].option2.replace(" Servings", "")) / parseInt(selectedVariantList[0].option2.replace(" Servings", ""))) - selectedVariantList[i].price;
    //   document.querySelector(`[data-each-price-${i}]`).innerHTML = "Save $" + Number(priceEach / 100).toFixed(2);
    //   if (data[1] && data[1].value != "") {
    //     document.querySelector(`[data-each-price-${i}]`).innerHTML = "Save $" + Number( priceEach / 100 + (selectedVariantList[i].price * (subscriptionDiscountValue / 100)) / 100).toFixed(2);
    //   }
    // }
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);
function updatePricesFromVariants(matchingElement) {
  // Get Member and Elite price cells
  const memberCell = document.querySelector(".member-cell");
  const eliteCell = document.querySelector(".elite-cell");
  const marketCell = document.querySelector(".market-cell ");
  console.log("updatePricesFromVariant");
  if (!matchingElement) {
    console.log("No matching variant found. Hiding Member and Elite cells.");

    // Hide the cells if no match is found
    if (memberCell) memberCell.style.display = "none";
    if (eliteCell) eliteCell.style.display = "none";

    return;
  }

  // Show the cells if a match is found
  if (memberCell) memberCell.style.display = "";
  if (eliteCell) eliteCell.style.display = "";
  if (marketCell) marketCell.style.display = "";

  // Get data-m and data-e from the matching variant element
  const memberPrice = matchingElement.getAttribute("data-m");
  const elitePrice = matchingElement.getAttribute("data-e");
  const marketPrice = matchingElement.getAttribute("data-o");

  // Update Original price
  if (marketCell && marketPrice !== null) {
    const marketPriceSpan = marketCell.querySelector(".price");
    if (marketPriceSpan)
      marketPriceSpan.textContent = `$${Number(marketPrice / 100).toFixed(2)}`;
  }

  // Update Member price
  if (memberCell && memberPrice !== null) {
    const memberPriceSpan = memberCell.querySelector(".price");
    if (memberPriceSpan)
      memberPriceSpan.textContent = `$${parseFloat(memberPrice).toFixed(2)}`;
  }

  // Update Elite price
  if (eliteCell && elitePrice !== null) {
    const elitePriceSpan = eliteCell.querySelector(".price");
    if (elitePriceSpan)
      elitePriceSpan.textContent = `$${parseFloat(elitePrice).toFixed(2)}`;
  }

  console.log(
    `Updated prices: Member - $${memberPrice}, Elite - $${elitePrice}`
  );
}
function checkAndUpdatePrice() {
  // Get all currently checked input values
  const checkedValues = Array.from(
    document.querySelectorAll('input[type="radio"]:checked')
  ).map((ele) => ele.value);
  console.log(checkedValues, "checkedValues");
  // Find the matching element in `variantElements`
  const matchingElement = Array.from(variantEl).find((element) => {
    const dataV = element.getAttribute("data-v"); // Get the 'data-v' attribute value
    const options = dataV.split("/").map((item) => item.trim()); // Split and trim the values

    // Compare the options with checked values
    return options.every((option) => checkedValues.includes(option));
  });

  // Update prices or hide cells based on the matching variant
  updatePricesFromVariants(matchingElement);
}
// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     checkAndUpdatePrices();
//   }, 100);
// });
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    var main = this;
    this.currentVariant;
    this.product = JSON.parse(
      document.getElementById("data-product").textContent
    );
    this.addEventListener("change", this.onVariantChange);
    this.productImageSlider = document.querySelector("product-image-slider");
    this.quantitySelector = this.querySelector("fieldset.Quantity");
    this.subscriptionSelector = document.querySelectorAll(
      "input[type=radio][name=selling_plan]"
    );

    this.updateOptions();
    this.setVariantOptions();
    this.updateMasterId();

    if (this.subscriptionSelector) {
      // Watch for variant selection to update selling plan option selectors
      this.subscriptionSelector.forEach(function (optionSelector) {
        optionSelector.addEventListener("change", function () {
          variantChangeFunc(main.currentVariant);
          changeBuyNowForm(main.currentVariant);
          main.setQuantityPrice();
        });
      });
    }
  }

  onVariantChange(e) {
    this.updateOptions();
    this.setVariantOptions(e);
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(false, "", false);
      this.setUnavailable();
    } else {
      variantChangeFunc(this.currentVariant);
      changeBuyNowForm(this.currentVariant);
      this.updateVariantInput();
      this.updateURL();
      this.colorChange(e);
      this.updateMedia();
      this.setQuantityPrice();
      if (this.currentVariant.available) {
        this.toggleAddButton(false, "", false);
      } else {
        this.toggleAddButton(true, window.variantStrings.soldOut, false);
      }
      //this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariant(this.options);
  }

  getVariant(values) {
    return this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return values[index] === option;
        })
        .includes(false);
    });
  }

  colorChange(e) {
    if (!window.colorsData) return;
    if (e.target.name != "Flavor") return;

    document.documentElement.style.setProperty(
      "--color-base-accent-2",
      window.colorsData[this.currentVariant.id].color
    );
    document.documentElement.style.setProperty(
      "--color-base-accent-2-light",
      window.colorsData[this.currentVariant.id].colorLight
    );
    document.documentElement.style.setProperty(
      "--color-base-accent-2-dark",
      window.colorsData[this.currentVariant.id].colorDark
    );
    document.documentElement.style.setProperty(
      "--color-base-accent-2-darker",
      window.colorsData[this.currentVariant.id].colorDarker
    );
  }

  mapMedia(obj, size, items, div) {
    var imagesHtml = obj
      .map(function (media, idx) {
        if (idx < items) {
          return `<div class="keen-slider__slide number-slide${idx} relative w-full min-w-[100%]"> 
                <div class="lightroom-button_container absolute top-3 right-3 z-10">
                  <button  class="lightroom-button p-2.5 rounded-full bg-accent-2-light transition duration-150 ease" data-src="${media.src}&width=1400"> 
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                    </svg>
                  </button>
                </div>
                <div class="relative flex items-center w-full h-full overflow-hidden" style="padding-bottom: 100%;">
                    <img
                        src="${media.src}&width=${size}"
                        width="${media.width}"
                        height="${media.height}"
                        alt="${media.alt}"
                        class="absolute max-w-full h-full w-full top-0 left-0 object-cover object-center"
                      >
                </div>
              </div>`;
        }
      })
      .join("");

    div.innerHTML = imagesHtml;
  }

  updateMedia() {
    if (!this.currentVariant) return;

    var mediaObj = [];
    var selectedVariant = this.currentVariant;
    var selectedOptions = this.currentVariant.options;

    mediaObj.push(selectedVariant.featured_image);

    this.product.media.filter(function (media, idx) {
      if (media.alt == null) return;

      if (
        selectedOptions.every(function (option) {
          return media.alt.includes(option);
        }) ||
        media.alt.includes(`all_${selectedOptions[0]}`)
      ) {
        if (media.src == selectedVariant.featured_image.src) return;
        return mediaObj.push(media);
      }
    });

    this.mapMedia(
      mediaObj,
      750,
      8,
      document.querySelector(".product-image-slider")
    );
    this.mapMedia(
      mediaObj,
      110,
      8,
      document.querySelector(".product-image-thumbs")
    );

    this.productImageSlider.onUpdate();
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // fetch(
    //   `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    // )
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const id = `price-${this.dataset.section}`;
    //     const html = new DOMParser().parseFromString(responseText, "text/html");
    //     const destination = document.getElementById(id);
    //     const source = html.getElementById(id);

    //     if (source && destination) destination.innerHTML = source.innerHTML;

    //     const price = document.getElementById(`price-${this.dataset.section}`);

    //     if (price) price.classList.remove("visibility-hidden");
    //   });

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const buyNowButton = document.querySelector("#buyNowButton");
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.innerHTML = text;
      if (buyNowButton) {
        buyNowButton.setAttribute("disabled", "disabled");
        buyNowButton.classList.add("opacity-60");
      }
    } else {
      addButton.removeAttribute("disabled");

      let actual_price = Number(this.currentVariant.price / 100).toFixed(2);
      let final_price = Number(this.currentVariant.price / 100).toFixed(2);
      // MEMBER PRICE UPDATE
      const membership_price_wrapper =
        document.querySelector("[data-membership]");
      if (membership_price_wrapper) {
        let memberPrice = final_price;
        let elitePrice = final_price;

        const memberPriceContainer = document.querySelector(
          `[data-vid='${this.currentVariant.id}']`
        );
        if (memberPriceContainer) {
          memberPrice = memberPriceContainer.dataset.m;
        }
        if (memberPriceContainer) {
          elitePrice = memberPriceContainer.dataset.e;
        }
        if (document.querySelector("[data-membership]").dataset.membership) {
          final_price = Number(
            document.querySelector("[data-membership]").dataset.membership ==
              "elite_member"
              ? elitePrice
              : memberPrice
          ).toFixed(2);
        }
      }

      if (document.querySelector(".savings")) {
        const member_price_variant = document.querySelector(
          `[data-vid='${this.currentVariant.id}']`
        ).dataset.m;
        document.querySelector(".savings").innerHTML = `$${Number(
          actual_price - Number(member_price_variant).toFixed(2)
        ).toFixed(2)}`;
      }
      if (document.querySelector(".elite_savings")) {
        const elite_price_variant = document.querySelector(
          `[data-vid='${this.currentVariant.id}']`
        ).dataset.e;
        document.querySelector(".elite_savings").innerHTML = `$${Number(
          actual_price - Number(elite_price_variant).toFixed(2)
        ).toFixed(2)}`;
      }

      console.log(final_price, "FINAL PRICE");
      addButtonText.innerHTML =
        window.variantStrings.addToCart +
        ` - <span data-final-price>$${final_price}</span>`;
      console.log("I am here too");
      checkAndUpdatePrice();
      if (buyNowButton) {
        buyNowButton.removeAttribute("disabled");
        buyNowButton.classList.remove("opacity-60");
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.innerHtml = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  setQuantityPrice() {
    if (!this.quantitySelector) return;

    var quantityOptionsArray = ["Single", "3 Pack"];
    var isSubscription = document.querySelector(
      "input[name=selling_plan]:checked"
    );

    var singleValues = this.options.filter((value) => {
      return !quantityOptionsArray.includes(value);
    });

    var packValues = this.options.filter((value) => {
      return !quantityOptionsArray.includes(value);
    });

    singleValues.push("Single");
    packValues.push("3 Pack");

    var singleVariant = this.getVariant(singleValues);
    var packVariant = this.getVariant(packValues);

    if (singleVariant) {
      var singleVariantPrice = singleVariant.price;
      if (isSubscription && isSubscription.value != "") {
        singleVariantPrice = singleVariant.price - singleVariant.price * 0.2;
      }
    }

    if (packVariant) {
      var packVariantPrice = packVariant.price;
      if (isSubscription && isSubscription.value != "") {
        singleVariantPrice = singleVariant.price - singleVariant.price * 0.2;
        packVariantPrice = packVariant.price - packVariant.price * 0.2;
      }
    }

    this.quantitySelector.querySelectorAll("input").forEach(function (radio) {
      var dataSingleValue = radio.parentElement.querySelector(
        `label[for='${radio.id}'] span[data-single-value]`
      );
      var dataSaleValue = radio.parentElement.querySelector(
        `label[for='${radio.id}'] span[data-value-save]`
      );

      if (radio.value == "Single") {
        if (singleVariant) {
          dataSingleValue.innerHTML = `$${(singleVariantPrice / 100).toFixed(
            2
          )} Per One`;
          if (singleVariant.compare_at_price) {
            dataSaleValue.classList.remove("hidden");
            dataSaleValue.innerHTML = singleVariant.compare_at_price
              ? `Save $${(
                  (singleVariant.compare_at_price - singleVariantPrice) /
                  100
                ).toFixed(2)}`
              : ``;
          } else {
            dataSaleValue.classList.add("hidden");
          }
        }
      } else {
        if (packVariant) {
          dataSingleValue.innerHTML = `$${(packVariantPrice / 3 / 100).toFixed(
            2
          )} Per One`;
          if (packVariant.compare_at_price) {
            dataSaleValue.classList.remove("hidden");
            dataSaleValue.innerHTML = packVariant.compare_at_price
              ? `Save $${(
                  (packVariant.compare_at_price - packVariantPrice) /
                  100
                ).toFixed(2)}`
              : ``;
          } else {
            dataSaleValue.classList.add("hidden");
          }
        } else {
          dataSingleValue.innerHTML = "Not Available";
          dataSaleValue.classList.add("hidden");
        }
      }
    });
  }

  setVariantOptions(e) {
    if (!this.quantitySelector) return;
    var that = this;
    var filterVariants = [];

    var quantityOptionsArray = ["Single", "3 Pack"];

    this.options = this.options.filter((value) => {
      return !quantityOptionsArray.includes(value);
    });

    this.product.variants.filter(function (variant, idx) {
      if (
        that.options.every(function (target) {
          return variant.options.includes(target);
        })
      ) {
        return filterVariants.push(variant);
      }
    });

    if (e && e.target.name != "Quantity") {
      if (this.quantitySelector) {
        if (filterVariants[0] && filterVariants[1]) {
          this.quantitySelector
            .querySelectorAll("input[name='Quantity']")[0]
            ?.setAttribute("disabled", false);
          this.quantitySelector
            .querySelectorAll("input[name='Quantity']")[1]
            ?.setAttribute("disabled", false);
          this.quantitySelector
            .querySelectorAll("fieldset.Quantity label")[1]
            ?.classList.remove("opacity-50");
          this.options.push(
            Array.from(this.quantitySelector.querySelectorAll("input")).find(
              (radio) => radio.checked
            ).value
          );
        } else {
          this.quantitySelector
            .querySelectorAll("input[name='Quantity']")[0]
            ?.setAttribute("disabled", false);
          this.quantitySelector
            .querySelectorAll("input[name='Quantity']")[0]
            ?.setAttribute("checked", true);
          this.quantitySelector
            .querySelectorAll("input[name='Quantity']")[1]
            ?.setAttribute("disabled", true);
          this.quantitySelector
            .querySelectorAll("fieldset.Quantity label")[1]
            ?.classList.add("opacity-50");
          this.options.push("Single");
        }
      }
    } else {
      var option = Array.from(
        this.quantitySelector.querySelectorAll("input")
      ).find((radio) => radio.checked).value;
      this.options.push(option);
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Defer Background Image

document.addEventListener("DOMContentLoaded", function () {
  var lazyBackgrounds = [].slice.call(
    document.querySelectorAll(".lazy-background")
  );

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});

if (!customElements.get("product-form")) {
  var sellingPlanContainer = document.querySelector(".selling-plan-fieldset");

  if (sellingPlanContainer) {
    var product = JSON.parse(
      document.getElementById("data-product").textContent
    );
    var productForm = document
      .querySelector(".product-form")
      .querySelector("form");

    // Watch for variant selection to update selling plan option selectors
    document
      .querySelectorAll("input[type=radio][name=selling_plan]")
      .forEach(function (optionSelector) {
        optionSelector.addEventListener("change", function () {
          var isSubscription = this.value == "" ? false : true;
          if (isSubscription) {
            sellingPlanContainer.classList.remove("hidden-form");
          } else {
            sellingPlanContainer.classList.add("hidden-form");
          }
        });
      });

    // document.querySelector('[data-subscription]').click();

    // Watch for selling plan option change to update the selected selling plan
    sellingPlanContainer
      .querySelector("select")
      .addEventListener("change", function () {
        document
          .querySelector("[data-subscription]")
          .setAttribute("value", this.value);
        console.log(
          document.querySelector('.product form input[name="id"]').value
        );
        changeBuyNowForm(
          document.querySelector('.product form input[name="id"]').value
        );
      });
  }
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.variantRadios = document.querySelector("variant-radios");

        this.buyMembership = document.getElementById("accept_policy");
        this.memberProduct = document.querySelector(
          ".cc-pricing-table-wrap"
        )?.dataset?.elite;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        const cartDrawer = document.getElementById("drawer-cart");
        //this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-container").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartItems.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);

        config.body = formData;

        if (this.buyMembership && this.buyMembership.checked) {
          setTimeout(async () => {
            const formData = {
              items: [
                {
                  id: this.memberProduct,
                  quantity: 1,
                  properties: { _type: "hide" },
                },
              ],
            };

            try {
              const response = await fetch(
                window.Shopify.routes.root + "cart/add.js",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(formData),
                }
              );

              if (!response.ok) throw new Error("Failed to add item to cart");
              const data = await response.json();
              this.buyMembership.checked = false;
              document.querySelector(
                ".cc-pricing-table-member-cell"
              ).style.display = "none";

              // price_table.style.display = 'none';
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                  }

                  document.getElementById(
                    "main-cart-drawer-items"
                  ).scrollTop = 0;
                  this.cartItems.renderAddToCart(response);
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  submitButton.classList.remove("loading");
                  submitButton.removeAttribute("aria-disabled");
                  this.querySelector(".loading-container").classList.add(
                    "hidden"
                  );
                  if (cartDrawer.ariaHidden == "true") {
                    document
                      .querySelector('[data-drawer-target="drawer-cart"]')
                      .click();
                  } else {
                    document.querySelector(
                      "#drawer-cart .offcanvas-body cart-items"
                    ).scrollTop = 0;
                  }
                });
            } catch (error) {
              console.error("Error adding item to cart:", error);
            }
          }, 500);
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              }

              if(window.location.href.includes('/cart')){
                window.location.reload()
              }else{
              document.getElementById("main-cart-drawer-items").scrollTop = 0;
              this.cartItems.renderAddToCart(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-container").classList.add("hidden");
              if (cartDrawer.ariaHidden == "true") {
                document
                  .querySelector('[data-drawer-target="drawer-cart"]')
                  .click();
              } else {
                document.querySelector(
                  "#drawer-cart .offcanvas-body cart-items"
                ).scrollTop = 0;
              }
            });
        }
      }
      // handleEliteItem() {

      // }
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.cartDrawer = document.querySelector("cart-drawer");
    this.productList = document.querySelector(".product_list");
    this.productListItem = document.querySelector(".product_list--item");
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    this.cartItems = "main-cart-items";
    this.cartFooter = "main-cart-footer";
    this.cartItemSelector = ".js-contents";

    if (!document.body.classList.contains("cart")) {
      if (this.productListItem) {
        this.productList.classList.remove("hidden");
      } else {
        this.productList.classList.add("hidden");
      }
      this.cartItems = "main-cart-drawer-items";
      this.cartFooter = "main-cart-drawer-footer";
      this.cartItemSelector = ".cart_items--main";
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: this.cartItems,
        section: this.cartItems,
        selector: this.cartItemSelector,
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: this.cartFooter,
        section: this.cartFooter,
        selector: `#${this.cartFooter}`,
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById(this.cartFooter);

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        this.disableLoading();
      })
      .catch((e) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  renderAddToCart(parsedState) {
    const cartFooter = document.getElementById(this.cartFooter);
    if (cartFooter) cartFooter.classList.remove("is-empty");
    this.classList.remove("is-empty");
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    //this.cartDrawer.onOpen();
  }

  updateLiveRegions(line, itemCount) {
    // Causing error on cart without actual errors
    // if (this.currentItemCount === itemCount) {
    //   document.getElementById(`Line-item-error-${line}`)
    //     .querySelector('.cart-item__error-text')
    //     .innerHTML = window.cartStrings.quantityError.replace(
    //       '[quantity]',
    //       document.getElementById(`Quantity-${line}`).value
    //     );
    // }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    var newCartData = new DOMParser().parseFromString(html, "text/html");

    if (
      !newCartData.querySelector(".product_list--item") &&
      newCartData.querySelector(".product_list")
    ) {
      newCartData.querySelector(".product_list").className += " hidden";
    }

    return newCartData.querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById(this.cartItems)
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-container`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById(this.cartItems)
      .classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

function loadZendeskChat(type, callback) {
  var zdscript = document.createElement("script");
  zdscript.defer = true;
  if (type == "zendesk") {
    zdscript.setAttribute("id", "ze-snippet");
    zdscript.src =
      "https://static.zdassets.com/ekr/snippet.js?key=32f78d51-af14-4c64-ae00-6274695710c9";
  }

  zdscript.onload = function () {
    callback();
  };

  document.getElementsByTagName("body")[0].appendChild(zdscript);
}

window.loadAndOpenZendeskChat = function (type) {
  if (type === "zendesk") {
    var button = document.getElementById("zdbutton");
  }

  button.innerHTML = `<div role="status">
                <svg aria-hidden="true" class="w-6 h-6 animate-spin ${
                  type === "zendesk"
                    ? "text-black text-opacity-30 fill-black"
                    : "text-white fill-gray-600"
                }" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                <span class="sr-only">Loading...</span>
            </div>`;

  loadZendeskChat(type, function () {
    if (typeof zE !== "undefined" && type == "zendesk") {
      zE(() => {
        zE.activate();
        window.setTimeout(function () {
          button.parentNode.removeChild(button);
        }, 500);
      });
    }
  });
};

class VariantOptionSelect extends HTMLElement {
  constructor() {
    super();
    this.options = [];
    this.currentVariant;
    this.currentVariantPrice;
    this.discount = this.dataset.discount;
    this.productForm = this.querySelector(
      `#product-form-${this.dataset.block}`
    );
    this.select = this.querySelector("select");
    this.radio = this.querySelector('input[name="Quantity"]');
    this.salePrice = this.querySelector("[data-sale-price]");
    this.originalPrice = this.querySelector("[data-original-price]");
    this.discountValue = this.querySelector("[data-discount-value]");
    this.cardImage = this.querySelector("[data-card-image]");
    this.product = JSON.parse(this.querySelector(".data-product").textContent);

    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.setVariantOptions(e);
    this.updateRadioOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updatePrice();
    this.updateMedia();
    this.renderProductInfo();
  }

  updateOptions() {
    if (this.select) {
      this.options = this.querySelector("select").value.split(",");
    }
  }

  updateRadioOptions() {
    if (this.radio) {
      var variantValue = Array.from(
        this.querySelectorAll("input[name='Quantity']")
      ).find((r) => r.checked).value;
      this.options.push(variantValue);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForm = this.querySelector("form");
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  updatePrice() {
    var originalPrice = this.currentVariant.price;
    this.originalPrice.innerHTML = "$" + Number(originalPrice / 100).toFixed(2);
    this.salePrice.innerHTML =
      "$" + Number((originalPrice * this.discount) / 10000).toFixed(2);
    this.discountValue.innerHTML = Math.floor(100 - this.discount) + "% OFF";
  }

  updateMedia() {
    this.cardImage.innerHTML = `<img src='${this.currentVariant.featured_image.src}&width=600' class='absolute max-w-full h-full w-full top-0 left-0 object-cover object-center' alt='${this.currentVariant.featured_image.alt}'/>`;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector(".data-product").textContent);
    return this.variantData.variants;
  }

  renderProductInfo() {
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
  }

  setVariantOptions(e) {
    var filterVariants = [];
    var availableVariants = [];
    var quantitySelector = this.querySelector("fieldset.Quantity");
    var targetVariants = e.target.value.split(",");

    this.product.variants.filter(function (variant, idx) {
      if (
        targetVariants.every(function (target) {
          return variant.title.includes(target);
        })
      ) {
        return filterVariants.push(...variant.options);
      }
    });

    var availableVariants = filterVariants.filter(function (
      item,
      index,
      inputArray
    ) {
      return inputArray.indexOf(item) == index;
    });

    if (e.target.name == "Quantity") return;

    if (quantitySelector) {
      if (availableVariants.indexOf("3 Pack") === -1) {
        quantitySelector.querySelectorAll(
          "input[name='Quantity']"
        )[0].disabled = false;
        quantitySelector.querySelectorAll(
          "input[name='Quantity']"
        )[0].checked = true;
        quantitySelector.querySelectorAll(
          "input[name='Quantity']"
        )[1].disabled = true;
        quantitySelector
          .querySelectorAll("fieldset.Quantity label")[1]
          .classList.add("opacity-60");
      } else {
        quantitySelector.querySelectorAll(
          "input[name='Quantity']"
        )[0].disabled = false;
        quantitySelector.querySelectorAll(
          "input[name='Quantity']"
        )[1].disabled = false;
        quantitySelector
          .querySelectorAll("fieldset.Quantity label")[1]
          .classList.remove("opacity-60");
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    if (!this.productForm) return;
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = this.productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("opacity-70");
      if (text) addButtonText.innerHTML = text;
    } else {
      checkAndUpdatePrices();
      var originalPrice =
        "$" +
        Number((this.currentVariant.price * this.discount) / 10000).toFixed(2);
      addButton.removeAttribute("disabled");
      addButton.classList.remove("opacity-70");
      addButton.style.opactiy = 1;
      addButtonText.innerHTML =
        window.variantStrings.addToCart +
        ` - <span data-final-price>${originalPrice}</span>`;
      console.log("I am here");
    }

    if (!modifyClass) return;
  }
}

customElements.define("variant-options", VariantOptionSelect);

class SliderModal extends HTMLElement {
  constructor() {
    super();
    var that = this;
    this.videoSrc = this.dataset.video;
    this.videoHeight = this.dataset.videoHeight;
    this.videoWidth = this.dataset.videoWidth;
    this.showModalButton = this.querySelector("[data-modal-visible]");
    this.modal = document.querySelector("#UGC_modal");
    this.video = this.modal.querySelector("video");
    this.source = this.modal.querySelector("source");
    this.close = document.querySelectorAll("[data-modal-close]");

    this.showModalButton.addEventListener("click", this.onShow.bind(this));

    this.close.forEach((close) => {
      close.addEventListener("click", that.onHide.bind(that));
    });
  }

  onShow() {
    this.source.setAttribute("width", this.videoWidth);
    this.source.setAttribute("height", this.videoHeight);
    this.source.setAttribute("src", this.videoSrc);
    this.video.load();
    this.video.play();
    this.modal.classList.remove("hidden");
    this.modal.classList.add("flex");
  }

  onHide() {
    this.modal.classList.add("hidden");
    this.modal.classList.remove("flex");
    this.video.pause();
    this.source.setAttribute("height", "1600");
    this.source.setAttribute("width", "900");
    this.source.setAttribute("src", "");
  }
}

customElements.define("slider-modal", SliderModal);

AOS.init({
  offset: mobileCheck() ? 120 : 280,
  duration: 600,
  easing: "ease",
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all product cards
  var productCards = document.querySelectorAll(".variant_card");
  productCards.forEach(function (card) {
    // Find the anchor tag inside the card
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    if (link) {
      link.addEventListener("click", function () {
        var item = {
          item_name: card.getAttribute("data-item-name"),
          item_id: card.getAttribute("data-item-id"),
          price: parseFloat(card.getAttribute("data-item-price")),
          item_brand: card.getAttribute("data-item-brand"),
          item_category: card.getAttribute("data-item-category"),
          item_variant: card.getAttribute("data-item-variant"),
          index: parseInt(card.getAttribute("data-item-index")),
          quantity: 1,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        var currency = window.shopCurrency || "USD";
        window.dataLayer.push({
          event: "select_item",
          ecommerce: {
            currency: currency,
            value: item.price,
            items: [item],
          },
        });
      });
    }
    if (img) {
      img.addEventListener("click", function () {
        var item = {
          item_name: card.getAttribute("data-item-name"),
          item_id: card.getAttribute("data-item-id"),
          price: parseFloat(card.getAttribute("data-item-price")),
          item_brand: card.getAttribute("data-item-brand"),
          item_category: card.getAttribute("data-item-category"),
          item_variant: card.getAttribute("data-item-variant"),
          index: parseInt(card.getAttribute("data-item-index")),
          quantity: 1,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        var currency = window.shopCurrency || "USD";
        window.dataLayer.push({
          event: "select_item",
          ecommerce: {
            currency: currency,
            value: item.price,
            items: [item],
          },
        });
      });
    }
  });
});
